export const CHANGE_COMPARE_DATA = 'dataOvervie/change_compare_data'
export const CHANGE_FILTER_DATA = 'dataOvervie/change_filter_data'
export const CHANGE_PARAM_DATAS = 'dataOvervie/change_param_datas'
export const CHANGE_QUESTION_DATA = 'dataOvervie/change_question_data'
